import Utils from 'swiper/src/utils/utils';
import isLive from './Carbon.Frontend/Resources/Private/Assets/Scripts/isLive';

const sprite = document.body.dataset.sprite;

import {
    $,
    addClass,
    removeClass,
    parent,
    find,
    remove,
    add,
    insertAfter,
    appendTo,
} from 'dom7/dist/dom7.modular';

const Methods = {
    addClass,
    removeClass,
    parent,
    find,
    remove,
    add,
    insertAfter,
    appendTo,
};

Object.keys(Methods).forEach((methodName) => {
    $.fn[methodName] = Methods[methodName];
});

Object.keys(Methods).forEach((methodName) => {
    $.fn[methodName] = Methods[methodName];
});

function getDefaultSettings(nummberOfSlides = 2) {
    return {
        fadeEffect: {
            crossFade: true,
        },
        spaceBetween: 30,
        simulateTouch: nummberOfSlides > 1 && isLive ? true : false,
        allowTouchMove: nummberOfSlides > 1 && isLive ? false : true,
        on: {
            init: function () {
                let slider = this.el;
                let params = this.originalParams;
                params.init = true;
                setTimeout(function () {
                    slider.data = params;
                    $(slider).addClass('swiper--initialized-true');
                    setTimeout(function () {
                        $(slider).removeClass('-no-transition-delay');
                    }, 1000);
                }, 10);
            },
        },
    };
}

function createNavigationButtons() {
    let nav = ['prev', 'next'];
    let buttons = {};
    nav.forEach((key) => {
        let icon = 'slide-nav';
        buttons[key] = $(
            `<div class="swiper-button swiper-button-${key}"><svg class="icon icon-${icon}>"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${sprite}#icon-${icon}"></use></svg></div>`
        )[0];
    });
    return buttons;
}

function writeNavigationButtons({ slider, insertAfter = false }) {
    $(slider).parent().find('.swiper-button-prev,.swiper-button-next').remove();

    let buttons = createNavigationButtons();
    let $array = $(buttons.prev).add(buttons.next);
    if (insertAfter) {
        $array.insertAfter(slider);
    } else {
        $array.appendTo(slider);
    }

    return buttons;
}

function mergeSettings({ settings = {}, typeSettings = {}, nummberOfSlides }) {
    // Get default settings
    let options = getDefaultSettings(nummberOfSlides);
    // Overwrite options from typeSettings and settings
    return Utils.extend(options, typeSettings, settings);
}

export { getDefaultSettings, mergeSettings, writeNavigationButtons };
